import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { StorageService } from '../../services/common/storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ApiService } from '../../services/api.service';
import { LanguageService } from '../../services/languageService/language-service.service';

interface BannerDetails {
  BannerId: number;
  SectionType: string;
  Details: string;
  SpanishDetails?: string; 
}
export interface Testimonial {
  name: string;
  location?: string;
  rating: number;
  message: string;
  image: string;
}
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent {
  bannerDetailsList : BannerDetails[] = [];
  filteredBannerDetailsList: BannerDetails[] = [];
  selectedLang: string =''
  labels: any = {};
testimonials: Testimonial[] = [
  {
    name: 'Carla Mendoza',
    rating: 4.5,
    message: '“This solution addresses one of the biggest operational gaps agents face daily. The relisting capability is especially impactful—it transforms lost opportunities into structured, actionable data. It’s rare to see a product align this well with real-world workflows.”',
    image: 'assets/images/testimonial_img_1.png'
  },
  {
    name: 'Michael Johnson',
    rating: 5,
    message: '“What stood out to me is how practical this platform is. Instead of adding complexity, it simplifies how agents manage listings and follow-ups. The relisting feature alone can significantly improve conversion tracking and efficiency.”',
    image: 'assets/images/testimonial_img_2.png'
  },
  {
    name: 'Sophia Lee',
    rating: 4.5,
    message: '“This is not just another tool—it’s a workflow upgrade. The ability to reuse and relist intelligently ensures that effort is never wasted. It’s clearly built with a deep understanding of how agents actually work.”',
    image: 'assets/images/testimonial_img_3.png'
  }
];
  constructor(private router: Router,private storageService:StorageService,
    private commonService:CommonService,
    private spinner:NgxSpinnerService,
    private apiUrlHelper:ApiUrlHelper,
    private apiService:ApiService,
    private languageService: LanguageService
  ) { 
    //storageService.clearAll();
  }

  ngOnInit(){
    this.selectedLang = this.languageService.getLanguage(); // 'eng' or 'spa'
    this.setLanguageLabels(); 
    this.languageService.language$.subscribe(() => {
      this.selectedLang = this.languageService.getLanguage(); // 'eng' or 'spa'
      this.setLanguageLabels(); 
      this.applyLanguage(); 
    })
    this.bindData()
  }

  bindData(){
    this.spinner.show();
    const apiUrl = this.apiUrlHelper.apiUrl.bannerManagement.bannerDetailsList;
    this.apiService
      .doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data.Data) {
            this.bannerDetailsList = data.Data;
            this.applyLanguage();
            this.spinner.hide();
          }else{
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.spinner.hide();
          console.log(err);
        },
        complete: () => {},
      });
  }

  

  truncateText(text: string, limit: number): string {
    if (text.length <= limit) {
      return text;
    }
    
    let truncated = text.substring(0, limit);
    
    // Ensure we don't cut the last word
    let lastSpaceIndex = truncated.lastIndexOf(" ");
    if (lastSpaceIndex > 0) {
      truncated = truncated.substring(0, lastSpaceIndex);
    }
  
    return truncated;
  }

  navigateToCustomers()
  {
    this.storageService.setValue("userTypeId","2")
    let userType =this.commonService.Encrypt("2");
    this.router.navigate(['/signup'], {
      queryParams: {  usertype: userType },
    });
  }
  navigateToAgents()
  {
    this.storageService.setValue("userTypeId","3")
    let userType =this.commonService.Encrypt("3");
    this.router.navigate(['/signup'], {
      queryParams: {  usertype: userType },
    });
    // this.router.navigate(['/signup'])
  }

  applyLanguage() {
    this.filteredBannerDetailsList = this.bannerDetailsList.map(item => ({
      ...item,
      Details: this.selectedLang === 'spa' ? item.SpanishDetails || item.Details : item.Details
    }));
  }

  setLanguageLabels() {
    if (this.selectedLang === 'spa') {
      this.labels = {
        welcome: 'Bienvenido a Senem RFP',
        tagline: 'Una mejor manera de obtener un seguro de auto',
        customers: 'Clientes',
        agents: 'Agentes',
        getStarted: 'Comenzar ahora',
        bannerSubTitle: 'UN ENFOQUE PERFECTO PARA ENCONTRAR AGENTES DE SEGUROS'
      };
    } else {
      this.labels = {
        welcome: 'Welcome to Senem RFP',
        tagline: 'A better way to get auto insurance',
        customers: 'Customers',
        agents: 'Agents',
        getStarted: 'Get Started Now',
        bannerSubTitle: 'A PERFECT APPROACH TO THE <span>RIGHT</span> AUTO INSURANCE AGENTS'
      };
    }
  }
  getStars(rating: number): string[] {
  const stars = [];
  const full = Math.floor(rating);
  const half = rating % 1 !== 0;

  for (let i = 0; i < full; i++) {
    stars.push('full');
  }

  if (half) {
    stars.push('half');
  }

  while (stars.length < 5) {
    stars.push('empty');
  }

  return stars;
}
  
}
